import React, { useEffect, useContext, useState, useMemo, useCallback, useRef } from 'react';
import Client from '../../api/client';
import UserContext from '../../business/referential/UserContext';
import DataTable from '../../components/generic/DataTable';
import CopyrightUpdateWeb from '../../components/editor/CopyrightUpdateWeb'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { ThreeCircles } from 'react-loader-spinner';

function HistoricListing(props) {
    const [userData, setUserData] = useState(null);
    const ctx = useContext(UserContext);
    const fetchIdRef = useRef(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [rowData, setRowData] = useState(null);
    const [websiteId, setWebsiteId] = useState(null);
    const [search, setSearch] = useState('');
    const [show, setShow] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const [pageCount, setPageCount] = useState(0)
    const [pageId, setPageId] = useState(22);
    const [ready, setReady] = useState(false);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {

        if (data && data.length > 0) {
            setReady(true);
        }
    }, [data]);

    const handleUpdate = (original) => {
        setWebsiteId(original.id);
        setRowData(original.urls);
        setShow(true);
    }

    const successNotif = () => {
        NotificationManager.success(getContent("lblMessage"));
        setRefresh(refresh => refresh + 1);
    }


    const columns = useMemo(
        () => {
            if (userData && userData.dataContent) {
                return [
                    {
                        Header: getContent("TitleEditSite"),
                        columns: [
                            {
                                Header: getContent("COL1"),
                                accessor: 'id',
                                classNameHeader: "col-4 col-lg-3",
                                className: "col-4 col-lg-3 text-break"
                            },
                            {
                                Header: getContent("COL2"),
                                accessor: 'websiteUrl',
                                classNameHeader: "col-5 col-lg-4",
                                className: "col-5 col-lg-4 text-break"
                            },
                            {
                                Header: getContent("COL3"),
                                accessor: 'date',
                                classNameHeader: "col-3 col-lg-3",
                                className: "col-3 col-lg-3"
                            },
                            {
                                Header: 'Action',
                                Cell: ({ row: { original } }) => {
                                    return <>
                                        <button onClick={() => handleUpdate(original)} className="btn btn-outline-blue">{getContent("BtnUpdate")}</button>
                                    </>
                                },
                                classNameHeader: "col-4 col-lg-2",
                                className: "col-4 col-lg-2"
                            }
                        ],
                    },
                ];
            }
            else {
                return [];
            }
        },
        [userData]
    );


    const fetchData = useCallback(({ pageSize, pageIndex }) => {
        //d-flex g-0

        if (userData) {
            const getData = async () => {
                // Set the loading state
                setLoading(true)

                let datas = [];
                if (pageCount === 0 && pageSize > 0) {
                    await Client.getWebsiteListing(userData.userObject.id, pageIndex + 1, pageSize, search, false).then((r) => {
                        //console.log(r)
                        setPageCount(Math.ceil(r.data.totalRows / pageSize));
                        datas = r.data;
                    });
                }

                if (datas.length === 0) {
                    await Client.getWebsiteListing(userData.userObject.id, pageIndex + 1, pageSize, search, (refresh > 0)).then((r) => {
                        datas = r.data;
                    });
                }

                // Give this fetch an ID
                const fetchId = ++fetchIdRef.current

                //HERE FETCHING DATAS
                if (fetchId === fetchIdRef.current) {
                    const startRow = pageSize * pageIndex
                    const endRow = startRow + pageSize
                    setData(datas.data)
                    setLoading(false)
                }
            }
            getData();
        }
    }, [userData, refresh]);

    useEffect(() => {

        const process = async () => {

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });
        }
        process();

    }, []);

    return (<>
        {!show &&
            <div className="dashboard-container">
                <h3 className="mb-4 mb-md-5">
                    {getContent("TitleEditSite")}
                </h3>
                <div className="table-container">
                    {columns && data &&
                        <DataTable
                            columns={columns}
                            data={data}
                            fetchData={fetchData}
                            loading={ready}
                            pageCount={pageCount}
                            isPaginable={true}
                            classNameDiv="table-responsive-lg"
                            getRowProps={{ className: "d-flex g-0" }}
                            getHeadProps={{ className: "d-flex g-0" }}
                        />}
                </div>
                <ThreeCircles
                    height="100"
                    width="100"
                    color="#3898ff"
                    wrapperStyle={{ flex: 1, marginTop: 240, justifyContent: 'center', alignItems: 'center' }}
                    wrapperClass=""
                    visible={(ready === false)}
                    ariaLabel="three-circles-rotating"
                    outerCircleColor=""
                    innerCircleColor=""
                    middleCircleColor=""
                />
                <a href="/dashboard" className="arrow-back"></a>
            </div>}
        <CopyrightUpdateWeb show={show} data={rowData} websiteId={websiteId} setShow={setShow} successNotif={successNotif} />
        <NotificationContainer />
        <a href="/dashboard" className="arrow-back"></a>
    </>
    );
}

export default HistoricListing;